// Tiny client-side progress counter, persisted in localStorage. Drives the
// coin badge on the title screen so it shows something real (races finished),
// not a fabricated currency balance. No network, no accounts.

const KEY = "bibleracers:races-finished";

export function getRacesFinished(): number {
  try {
    const n = Number(localStorage.getItem(KEY));
    return Number.isFinite(n) && n >= 0 ? n : 0;
  } catch {
    return 0;
  }
}

export function recordRaceFinished(): number {
  const next = getRacesFinished() + 1;
  try {
    localStorage.setItem(KEY, String(next));
  } catch {
    /* storage blocked — counter just won't persist */
  }
  return next;
}
